export default (routeKey, roleIds) =>
  new Promise((resolve, reject) => {
    window.axios
      .post(`${process.env.VUE_APP_API_ADMIN_LOCATION}permissions`, {
        route_key: routeKey,
        role_ids: roleIds,
      })
      .then(({ data }) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
